import { Outlet } from "react-router-dom";

export default function WorkflowLayout() {
  return (
    <div className="workflow-layout flex flex-col h-screen">
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
